(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    function shreeEnquiryContext() {
  const product = new URLSearchParams(window.location.search).get('product');
  if (!product || !/^[a-z0-9-]{1,180}$/.test(product)) return;
  document.querySelectorAll('[data-shree-product-context]').forEach(input => { input.value = product; });
}
shreeEnquiryContext();
document.addEventListener('shopify:section:load', shreeEnquiryContext);
  } catch(e) { console.error(e); }
})();

})();
